'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadialGauge = exports.LinearGauge = undefined;

var _LinearGauge = require('./LinearGauge');

var _LinearGauge2 = _interopRequireDefault(_LinearGauge);

var _RadialGauge = require('./RadialGauge');

var _RadialGauge2 = _interopRequireDefault(_RadialGauge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.LinearGauge = _LinearGauge2.default;
exports.RadialGauge = _RadialGauge2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-canvas-gauges/dist/index.js
// module id = 7001
// module chunks = 0